import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { KostDataImportProcessDataDe } from '../import-process';
import {
  KostDataImportNewUploadComponent,
  KostDataImportUploadConfig,
} from '@bindoc-projects/kost-data-import-lib/ui';
import { BD_JOB_SUBJECT_TYPE } from '@bindoc-projects/job-lib/logic';
import { KostDataImportDeService } from './kost.service';

@Component({
  selector: 'kost-data-import-de-new-upload',
  template: `
    <kost-data-import-new-upload [processData]="processData" [config]="config">
    </kost-data-import-new-upload>
  `,
  styles: ``,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [KostDataImportNewUploadComponent],
})
export class KostDataImportDeNewUploadComponent {
  private _kostDataImportDeService = inject(KostDataImportDeService);

  @Input()
  public processData: KostDataImportProcessDataDe;

  public readonly config: KostDataImportUploadConfig;

  constructor() {
    this.config = {
      uploader: () => {
        return this._kostDataImportDeService.create(this.processData);
      },
      chainSubject: (uploaded) =>
        hasId(uploaded)
          ? { type: BD_JOB_SUBJECT_TYPE.p21Import, id: uploaded.id }
          : null,
    };
  }
}

/** The P21 import row the upload created; its id is the chain's subject. */
function hasId(value: unknown): value is { id: string } {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    typeof value.id === 'string'
  );
}
